import styled from 'styled-components';
import {
  breakpoint,
  BodyText,
  ButtonRow,
  Heading,
  TertiaryButton,
} from '@grays-npm/component-library';
import { Modal, ModalProps, LoadingButton } from '../../../components';
import { ListingModalData, ListingModalTypeEnum } from './types';
import { useCMSData } from '../../../state/content-manager';

const Text = styled(BodyText)`
  margin: 0 0 ${({ theme }) => theme.spacings[4].rem};

  ${breakpoint('sm')`
    margin: ${({ theme: { spacings } }) =>
      `0 ${spacings[5].rem} ${spacings[5].rem} 0`};
  `}
`;

const Label = styled(BodyText)`
  color: ${({ theme }) => theme.colors.neutrals.transparentGrays[2]};
`;

const Value = styled(Heading)`
  ${({ theme }) => theme.typography.headings[3].xl};
  margin-bottom: ${({ theme }) => theme.spacings[7].rem};
`;

const CancelButton = styled(TertiaryButton)`
  min-width: 120px;
`;

type AcceptBidModalProps = Omit<ModalProps, 'title'> &
  ListingModalData<ListingModalTypeEnum.AcceptBid> & {
    onAcceptBid: () => void;
  };

export const AcceptBidModal: React.FC<AcceptBidModalProps> = ({
  isOpen,
  isButtonLoading,
  isSuccess,
  currentBidText,
  onAcceptBid,
  onClose,
}) => {
  const cmsData = useCMSData();
  const { actionText, body, title, successText } = cmsData.modals.acceptBid;
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      isSuccess={isSuccess}
      successText={successText}
    >
      <Text size="lg">{body}</Text>
      <Label size="md">Current Bid:</Label>
      <Value>{currentBidText}</Value>
      <ButtonRow>
        <LoadingButton
          onClick={onAcceptBid}
          onClose={onClose}
          size="large"
          disabled={isButtonLoading}
          isLoading={isButtonLoading}
          isSuccess={isSuccess}
        >
          {actionText}
        </LoadingButton>
        <CancelButton onClick={onClose} size="large">
          Cancel
        </CancelButton>
      </ButtonRow>
    </Modal>
  );
};
